export enum SessionType {
    NONE = "NONE",
    SINGLE_CLIENT = "SINGLE_CLIENT",
    MULTI_CLIENT = "MULTI_CLIENT",
    SUPPORT = "SUPPORT",
  }
  